import { map } from 'rxjs/operators';
import { EntityState } from './../image-slice-show/share/model';
import { EntityStoreModule } from './entity-store.module';
import {
  RingModel,
  EntityModel,
  LineModel,
  CrossLineModel,
  FovModel,
} from './../ng3/model';
import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { Color, Vector3, Line, Vector2 } from 'three';
import { ItemStore, Database, ArrayCollectionOf } from 'pistore';
import { noop, Observable } from 'rxjs';
import { BoundingBox2FromCenterSize } from '../ng3/share/boundingbox2';

export function initialRingEntityState(): EntityState {
  return {
    canvasId: uuid(),
    id: uuid(),
    model: new RingModel(new Vector3(0, 0, 0), 29.9, 30),
    color: new Color(60, 179, 113),
  };
}
export function initialWhichDraging(): WhichDraging {
  return {
    ring: true,
    line: false,
    crossline: false,
    fov: false,
  };
}
export interface Ids {
  canvasId: string;
  // newCanvasId: string;
}
export interface CanvasIdWithModels {
  canvasId: string;
  model: EntityModel;
}
export interface IdWithModel {
  id: string;
  model: EntityModel;
}
export interface Models {
  model: EntityModel;
}

export interface WhichDraging {
  ring: boolean;
  line: boolean;
  crossline: boolean;
  fov: boolean;
}

@Injectable({
  // providedIn: EntityStoreModule,
  providedIn: 'root',
})
export class EntityStoreService {
  updateFunction<T, K>(x: T, y: K): boolean {
    return false;
  }
  private toSearch = (x: EntityState): EntityState => x;
  private updateEqualCanvasRing = (
    x: CanvasIdWithModels,
    y: EntityState,
  ): boolean => x.canvasId === y.canvasId && y.model.type === 'ring';
  private updateEqualCanvasLine = (
    x: CanvasIdWithModels,
    y: EntityState,
  ): boolean => x.canvasId === y.canvasId && y.model.type === 'line';
  private updateEqualCanvasCrossLine = (
    x: CanvasIdWithModels,
    y: EntityState,
  ): boolean => x.canvasId === y.canvasId && y.model.type === 'crossline';
  private updateEqualFov = (x: IdWithModel, y: EntityState): boolean =>
    x.id === y.id && y.model.type === 'fov';
  private fromUpdateModelId = (
    x: IdWithModel,
    y: EntityState,
  ): EntityState => ({
    ...y,
    model: x.model,
  });
  private fromUpdateModel = (
    x: CanvasIdWithModels,
    y: EntityState,
  ): EntityState => ({
    ...y,
    model: x.model,
  });
  private updateEqualCrosslines = (x: Models, y: EntityState): boolean => true;
  private fromUpdateCrosslines = (x: Models, y: EntityState): EntityState => ({
    ...y,
    model: {
      ...(y.model as CrossLineModel),
      position: (x.model as CrossLineModel).position,
    },
  });
  private removeEqual = (x: Ids, y: EntityState): boolean =>
    x.canvasId === y.canvasId;
  private updateEqualAll = (x: Ids, y: EntityState): boolean => true;
  private fromUpdateId = (x: Ids, y: EntityState): EntityState => ({
    ...y,
    canvasId: x.canvasId,
    id: uuid(),
  });
  public whichDraging$ = new Observable<WhichDraging>();
  public entityArrayCollectionOf = new ArrayCollectionOf<EntityState>(
    new Array<EntityState>(initialRingEntityState()),
  );
  public entityStateStore = new ItemStore<
    EntityState,
    ArrayCollectionOf<EntityState>,
    true
  >(this.entityArrayCollectionOf, true);
  public entityRingDatabase = new Database<
    EntityState,
    CanvasIdWithModels,
    Ids,
    EntityState,
    EntityState,
    true
  >(
    this.entityStateStore,
    this.updateEqualCanvasRing,
    this.removeEqual,
    this.toSearch,
    this.fromUpdateModel,
  );
  public entityCrossLineDatabase = new Database<
    EntityState,
    CanvasIdWithModels,
    Ids,
    EntityState,
    EntityState,
    true
  >(
    this.entityStateStore,
    this.updateEqualCanvasCrossLine,
    this.removeEqual,
    this.toSearch,
    this.fromUpdateModel,
  );
  public entityCrossLinesDatabase = new Database<
    EntityState,
    Models,
    Ids,
    EntityState,
    EntityState,
    true
  >(
    this.entityStateStore,
    this.updateEqualCrosslines,
    this.removeEqual,
    this.toSearch,
    this.fromUpdateCrosslines,
  );
  public fovDatabese = new Database<
    EntityState,
    IdWithModel,
    Ids,
    EntityState,
    EntityState,
    true
  >(
    this.entityStateStore,
    this.updateEqualFov,
    this.removeEqual,
    this.toSearch,
    this.fromUpdateModelId,
  );
  public imageDatabase = new Database(this.entityStateStore);
  public selectedEntityStateStore = new ItemStore<
    EntityState,
    ArrayCollectionOf<EntityState>,
    true
  >(
    new ArrayCollectionOf<EntityState>(
      new Array<EntityState>(initialRingEntityState()),
    ),
    true,
  );
  public selectedEntityDatabase = new Database(this.selectedEntityStateStore);
  public clipBoardStore = new ItemStore<
    EntityState,
    ArrayCollectionOf<EntityState>,
    true
  >(
    new ArrayCollectionOf<EntityState>(
      new Array<EntityState>(initialRingEntityState()),
    ),
    true,
  );
  public clipBoardDatabase = new Database<
    EntityState,
    Ids,
    EntityState,
    EntityState,
    EntityState,
    true
  >(
    this.clipBoardStore,
    this.updateEqualAll,
    this.removeEqual,
    this.toSearch,
    this.fromUpdateId,
  );

  constructor() {
    this.clearSelected();
    this.clearClipBoard();
    this.clear();
  }

  addEntity(toAdd: EntityState) {
    this.entityRingDatabase.insert(toAdd).subscribe(noop, console.error);
  }
  selectEntity(selected: EntityState) {
    this.selectedEntityDatabase.insert(selected).subscribe(noop, console.error);
  }
  selectEntities(selected: EntityState[]) {
    this.selectedEntityDatabase
      .insertMany(selected)
      .subscribe(noop, console.error);
  }
  clearSelected() {
    this.selectedEntityStateStore
      .filter(p => false)
      .subscribe(noop, console.error);
  }
  clearClipBoard() {
    this.clipBoardStore.filter(p => false).subscribe(noop, console.error);
  }
  clear() {
    this.entityStateStore.filter(p => false).subscribe(noop, console.error);
  }
  updateRingEntity(toUpdate: CanvasIdWithModels) {
    this.entityRingDatabase.update(toUpdate).subscribe(noop, console.error);
  }
  updateCrosslineEntity(toUpdate: CanvasIdWithModels) {
    this.entityCrossLineDatabase
      .update(toUpdate)
      .subscribe(noop, console.error);
  }
  updateCrosslines(toUpdate: Models) {
    this.entityCrossLinesDatabase
      .updateMany(toUpdate)
      .subscribe(noop, console.error);
  }
  updateRings(toUpdate: CanvasIdWithModels[]) {
    this.entityRingDatabase
      .updateMany(...toUpdate)
      .subscribe(noop, console.error);
  }
  updateFov(toUpdate: IdWithModel) {
    this.fovDatabese.update(toUpdate).subscribe(noop, console.error);
  }
  removeEntity(toRemove: EntityState) {
    this.entityRingDatabase.remove(toRemove).subscribe(noop, console.error);
  }
  removeEntities(toRemove: EntityState[]) {
    this.entityRingDatabase
      .removeMany(...toRemove)
      .subscribe(noop, console.error);
  }
  removeEntityWithCanvasId(canvasId: string) {
    this.entityRingDatabase.remove({ canvasId }).subscribe(noop, console.error);
  }
  addRing(canvasId: string) {
    this.entityRingDatabase
      .insert({
        canvasId: canvasId,
        id: uuid(),
        model: new RingModel(new Vector3(0, 0, 0), 3, 3.0001),
        color: new Color(60, 179, 113),
      })
      .subscribe(noop, console.error);
  }
  addLine(canvasId: string) {
    this.entityRingDatabase
      .insert({
        canvasId: canvasId,
        id: uuid(),
        model: new LineModel(new Vector3(0, 0, 0), new Vector3(10, 0, 0)),
        color: new Color(60, 179, 113),
      })
      .subscribe(noop, console.error);
  }
  addCrossLine(canvasId: string) {
    this.entityRingDatabase
      .insert({
        canvasId: canvasId,
        id: uuid(),
        model: new CrossLineModel(new Vector3(0, 0, 0), 'z'),
        color: new Color(60, 179, 113),
      })
      .subscribe(noop, console.error);
  }
  addFov(canvasId: string, center = new Vector2(0, 0), size = new Vector2(30, 10)) {
    this.fovDatabese
      .insert({
        canvasId: canvasId,
        id: uuid(),
        model: new FovModel(
          new BoundingBox2FromCenterSize(
            center,
            size,
          ),
        ),
        color: new Color(60, 179, 113),
      })
      .subscribe(noop, console.error);
  }
  cutEntity(canvasId: string) {
    this.clearClipBoard();
    this.copyEntity(canvasId);
    this.removeEntityWithCanvasId(canvasId);
  }
  copyEntity(canvasId: string) {
    this.clearClipBoard();
    this.entitiesOfCanvas(canvasId)
      .pipe(
        map(e =>
          this.clipBoardDatabase
            .insertMany(...e)
            .subscribe(noop, console.error),
        ),
      )
      .subscribe(noop, console.error);
  }
  pasteEntity(canvasId: string) {
    this.clipBoardDatabase.update({ canvasId }).subscribe(noop, console.error);

    this.clipBoardDatabase
      .searchMany(x => true)
      .pipe(
        map(e =>
          this.entityRingDatabase
            .insertMany(...e)
            .subscribe(a => console.log(a), console.error),
        ),
      )
      .subscribe(noop, console.error);
  }
  entitiesOfCanvas(canvasId: string) {
    return this.entityRingDatabase.searchMany(x => x.canvasId === canvasId);
  }
  crosslineOnCanvas<T>(canvasId: string, op: (crossline: CrossLineModel) => T) {
    let current: CrossLineModel;
    this.getCrossline(canvasId)
      .pipe(
        map(x => {
          if (x === undefined) {
            return;
          }
          current = x.model as CrossLineModel;
          return op(current);
        }),
      )
      .subscribe(noop, console.error);

  }
  ringOnCanvas<T>(canvasId: string, op: (ring: RingModel) => T) {
    let current: RingModel;
    this.getRing(canvasId)
      .pipe(map(x => (current = x.model as RingModel)))
      .subscribe(noop, console.error);
    return op(current);
  }
  fovOnCanvas<T>(canvasId: string, op: (fov: EntityState) => T) {
    let current: EntityState;
    this.getFov(canvasId)
      .pipe(map(x => (current = x)))
      .subscribe(noop, console.error);
    return op(current);
  }
  fovsOnCanvas<T>(canvasId: string, op: (fov: EntityState[]) => T) {
    let current: EntityState[];
    this.getFovs(canvasId)
      .pipe(map(x => (current = x)))
      .subscribe(noop, console.error);
    return op(current);
  }
  showEntities() {
    return this.entityRingDatabase.searchMany(x => true);
  }
  showClipBoard() {
    return this.clipBoardDatabase.searchMany(x => true);
  }
  getRings() {
    return this.entityRingDatabase.searchMany(x => x.model.type === 'ring');
  }
  getRing(canvasId: string) {
    return this.entityRingDatabase.search(
      x => x.canvasId === canvasId && x.model.type === 'ring',
    );
  }
  getCircles() {
    return this.entityRingDatabase.searchMany(x => x.model.type === 'circle');
  }
  getFov(canvasId: string) {
    return this.fovDatabese.search(
      x => x.canvasId === canvasId && x.model.type === 'fov',
    );
  }
  getFovs(canvasId: string) {
    return this.fovDatabese.searchMany(
      x => x.canvasId === canvasId && x.model.type === 'fov',
    );
  }
  getCrossline(canvasId: string) {
    return this.entityCrossLineDatabase.search(
      x => x.canvasId === canvasId && x.model.type === 'crossline',
    );
  }
  // getCrosslines() {
  //   return this.entityCrossLinesDatabase.searchMany(
  //     x => x.model.type === 'crossline',
  //   );
  // }
  getROI() {}
}
